export const SELECT_HOME = 'SELECT_HOME';
export const SELECT_COMMUNITY = 'SELECT_COMMUNITY';
export const SELECT_STORE = 'SELECT_STORE';
export const SELECT_CURATIONS = 'SELECT_CURATIONS';
export const SELECT_SUBJECT = 'SELECT_SUBJECT';
export const SORT_SUBJECT_POSTS = 'SORT_SUBJECT_POSTS';
export const SELECT_SUBSCRIBED_CHANNELS = 'SELECT_SUBSCRIBED_CHANNELS';
export const SELECT_SUBSCRIBED_POSTS = 'SELECT_SUBSCRIBED_POSTS';
export const TOGGLE_SUBSCRIPTION = 'TOGGLE_SUBSCRIPTION';

export const TOGGLE_LIKE = 'TOGGLE_LIKE';
export const TOGGLE_BOOKMARK = 'TOGGLE_BOOKMARK';

export const SELECT_NOTIFICATIONS_UPDATE_CNT = 'SELECT_NOTIFICATIONS_UPDATE_CNT';
export const SELECT_NOTIFICATIONS = 'SELECT_NOTIFICATIONS';

export const TOGGLE_STORE_BOOKMARK = 'TOGGLE_STORE_BOOKMARK';
